import { render, staticRenderFns } from "./display-field-amount.vue?vue&type=template&id=5a81083f&scoped=true&"
import script from "./display-field-amount.ts?vue&type=script&lang=ts&"
export * from "./display-field-amount.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-amount.scss?vue&type=style&index=0&id=5a81083f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a81083f",
  null
  
)

export default component.exports